var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "md-column" } },
    [
      _c(
        "md-theme",
        { attrs: { "md-name": "blue" } },
        [
          _c("breadcrumbs", { attrs: { section: "Series", nav: _vm.nav } }),
          _c(
            "router-link",
            { attrs: { to: { name: "CreateSerie" } } },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-fab md-fab-bottom-right md-icon-button",
                  attrs: { id: "btn-add-series" }
                },
                [_c("md-icon", { attrs: { "md-iconset": "fa fa-plus" } })],
                1
              )
            ],
            1
          ),
          _c("serie-table", { staticClass: "content-table" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb151eda", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb151eda","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/serie/SerieList.vue
// module id = 872
// module chunks = 0